"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tick = function Tick(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M9.37463 18.2289C9.30627 18.229 9.23857 18.2156 9.17542 18.1894C9.11226 18.1633 9.0549 18.1249 9.00663 18.0765L6.9233 15.9931C6.82823 15.895 6.77555 15.7635 6.77663 15.6269C6.7777 15.4903 6.83244 15.3596 6.92904 15.263C7.02564 15.1664 7.15634 15.1117 7.29294 15.1106C7.42954 15.1095 7.56108 15.1622 7.65918 15.2573L9.74251 17.3406C9.81523 17.4134 9.86475 17.5061 9.8848 17.607C9.90486 17.708 9.89455 17.8126 9.85518 17.9076C9.81581 18.0027 9.74915 18.0839 9.66362 18.1411C9.57808 18.1983 9.47752 18.2289 9.37463 18.2289Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M8.33379 17.1873C8.26543 17.1874 8.19773 17.174 8.13457 17.1478C8.07142 17.1216 8.01406 17.0832 7.96579 17.0348L5.88246 14.9515C5.78714 14.8534 5.73426 14.7218 5.73524 14.5851C5.73622 14.4483 5.79099 14.3174 5.8877 14.2208C5.9844 14.1241 6.11528 14.0693 6.25203 14.0684C6.38878 14.0674 6.5204 14.1203 6.61845 14.2157L8.70178 16.299C8.77451 16.3718 8.82403 16.4645 8.84408 16.5654C8.86413 16.6664 8.85381 16.771 8.81443 16.866C8.77505 16.9611 8.70837 17.0424 8.62282 17.0995C8.53727 17.1567 8.43669 17.1873 8.33379 17.1873Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M13.5417 14.0625C13.4386 14.0625 13.3379 14.0319 13.2523 13.9747C13.1666 13.9175 13.0999 13.8361 13.0605 13.7409C13.021 13.6458 13.0107 13.541 13.0308 13.44C13.0509 13.339 13.1005 13.2462 13.1734 13.1733L19.4234 6.92334C19.5212 6.8265 19.6534 6.77235 19.7911 6.77271C19.9288 6.77307 20.0607 6.82792 20.158 6.92526C20.2554 7.02261 20.3102 7.15453 20.3106 7.29219C20.3109 7.42986 20.2567 7.56206 20.1599 7.65991L13.9099 13.9099C13.8616 13.9583 13.8042 13.9967 13.741 14.0229C13.6778 14.0491 13.6101 14.0625 13.5417 14.0625Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M9.37503 18.2292C9.27201 18.2292 9.17132 18.1987 9.08566 18.1414C9.00001 18.0842 8.93326 18.0029 8.89383 17.9077C8.85441 17.8125 8.8441 17.7078 8.8642 17.6068C8.88429 17.5057 8.9339 17.4129 9.00674 17.3401L15.2567 11.0901C15.3546 10.9933 15.4868 10.9391 15.6245 10.9395C15.7621 10.9398 15.894 10.9947 15.9914 11.092C16.0887 11.1894 16.1436 11.3213 16.1439 11.4589C16.1443 11.5966 16.0901 11.7288 15.9933 11.8267L9.74328 18.0767C9.69497 18.1251 9.63757 18.1635 9.57438 18.1897C9.51118 18.2159 9.44343 18.2293 9.37503 18.2292Z",
    fill: props.foregroundColor
  }));
};

Tick.defaultProps = {
  altText: "Tick",
  foregroundColor: "#2D5AB4"
};
Tick.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Tick;
exports.default = _default;